import React from 'react';

export default () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M39 19a15 15 0 00-29.9 0H3v24h42V19h-6z" fill="#fff" />
    <path
      opacity=".3"
      d="M45 19h-6v24h6V19zM9 19H3v24h6V19zM15 43h3V33a6 6 0 1112 0v10h3V25H15v18zM33 18a9 9 0 00-18 0v1h4.1c-.06.33-.1.66-.1 1v1h10v-1c0-.34-.04-.67-.1-1H33v-1zm-14.62-1.93l.36 1.09-.93-.68-.93.68.36-1.09-.93-.68h1.15l.35-1.09.35 1.09h1.15l-.93.68zm3-1.58l-.93-.67-.93.67.36-1.09-.93-.67h1.15l.35-1.09.36 1.09h1.14l-.95.67.38 1.09zm3.56-1.06l-.94-.68-.93.68.36-1.09-.93-.68h1.15l.35-1.09.35 1.09h1.15l-.93.68.37 1.09zm2.65.4l-.93.68.34-1.09-.93-.68h1.15l.35-1.09.35 1.09h1.15l-.93.68.36 1.09-.91-.68zm3.55 3.35l-.93-.68-.93.68.36-1.09-.93-.68h1.15l.35-1.09.35 1.09h1.14l-.93.68.37 1.09z"
      fill="#005CB7"
    />
    <path
      d="M9.05 19H3v24h6V20c0-.34 0-.67.05-1zM39 19v24h6V19h-6z"
      stroke="#005CB7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 5a15 15 0 0115 15v23H9V20A15 15 0 0124 5v0z"
      stroke="#005CB7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 9a9 9 0 00-9 9v1h4.1a5 5 0 019.8 0H33v-1a9 9 0 00-9-9z"
      stroke="#005CB7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 15a5 5 0 015 5v1H19v-1a5 5 0 015-5zM33 25H15v18h18V25z"
      stroke="#005CB7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
